module.exports = __webpack_public_path__ + "static/media/airplane_horizontal.1324722c.svg";